<button
  mat-button
  class="flex ib-btn ib-btn-icon cursor-pointer p-3px"
  *ngIf="formCtrl.value"
  (keyup)="$event.stopPropagation()"
  (click)="clear()"
>
  <i class="material-icons">clear</i>
</button>
